export const SET_LOADING_USERS = 'USERS_SET_LOADING_USERS';
export const LOAD_USERS = 'USERS_LOAD_USERS';
export const SET_CREATING_USER = 'USERS_SET_CREATING_USER';
export const CREATE_USER = 'USERS_CREATE_USER';
export const SET_UPDATING_USER = 'USERS_SET_UPDATING_USER';
export const UPDATE_USER = 'USERS_UPDATE_USER';
export const SET_DELETING_USER = 'USERS_SET_DELETING_USER';
export const DELETE_USER = 'USERS_DELETE_USER';
export const RESET = 'USERS_RESET';